<template>
    <v-container fluid class="grey lighten-5 pa-0 notes-print-preview">
        <v-row no-gutters>

            <!-- Main Content -->
            <div style="width: 100%">
                <v-container v-show="!isLoading" fluid class="content-container container-height" :class="!isMobilePort ? 'px-5' : ''">
                    <v-overlay :value="isLoading" absolute>
                        <v-progress-circular indeterminate size="64"/>
                    </v-overlay>
                    <default-content-section-controller
                        v-show="contentSections.length"
                        :renderToolbar="false"
                        :content-sections="contentSections"
                        :is-notes-section-expanded="true"
                        :show-all-bookmarks="true"
                        :showNoteControlMenu="false"
                        :customUserBookmarksSorOrders="getCustomUserBookmarksSortOrders()"/>
                    <v-row v-if="!isLoading && !contentSections.length" justify="center">
                        <v-col class="text-center" cols="12" sm="4">
                            <v-icon large color="primaryMedium">mdi-bookmark-multiple-outline</v-icon>
                            <h3 class="text-h6 font-weight-medium mt-2">No notes or bookmarks found here</h3>
                            <div class="text-body-1 text--secondary mt-2">
                                Try clearing your filters. Or try bookmarking sections and adding notes to get started.
                            </div>
                            <v-btn
                                outlined
                                color="primary"
                                href="https://support.iccsafe.org/ht_kb/digital-codes/how-to-create-notes/"
                                target="_blank"
                                class="mt-2"
                            >Learn About Notes
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container
                    v-if="isLoading"
                    fluid
                    class="content-container container-height"
                >
                    <loading>
                        <v-container style="max-width: 400px">
                            <v-row class="justify-center">
                                <span class="text-h6 font-weight-medium mb-2">
                                    Preparing your print job...
                                </span>
                            </v-row>
                            <v-row class="justify-center">
                                <span class="grey--text">
                                    This may take a moment, especially for larger sections/notes.
                                    If it's taking longer than expected, please re-filter to reduce the amount of sections.
                                </span>
                            </v-row>
                        </v-container>
                    </loading>
                </v-container>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

import Mobile from '../../inc/mixins/mobile';
import {ContentSectionApi} from "../../../api/ContentSectionApi";
import DefaultContentSectionController from "../../content-section/DefaultContentSectionController.vue";
import Loading from "../../content/partials/loading.vue";

export default {
    components: {DefaultContentSectionController, Loading},
    mixins: [Mobile],
    data() {
        return {
            isLoading: false,
            contentSections: [],
        };
    },
    mounted() {
        this.getContentSections();
    },
    methods: {
        getCustomUserBookmarksSortOrders() {
            let customSortOrders = localStorage.getItem('section_notes_sort_order_change');
            if (customSortOrders) {
                return JSON.parse(customSortOrders);
            }
            return undefined;
        },
        async getContentSections() {
            try {
                this.isLoading = true;
                const stored = localStorage.getItem("print_preview_query_params");
                const settings = JSON.parse(stored);
                const queryParams = {
                    ...settings,
                    offset: 0,
                    limit: 100000
                };
                const response = await ContentSectionApi.queryByUserNotes(queryParams);
                this.contentSections = response.pagination?.items;
                this.isLoading = false;
                this.$nextTick(function () {
                    window.print();
                })
            } catch (err) {
                if (!axios.isCancel(err)) {
                    this.isLoading = false;
                }
            }
        },
        buildQueryParams(filters) {
            const queryParams = {};
            for (const key in filters) {
                const value = filters[key];
                if (Array.isArray(value) && value.length > 0) {
                    queryParams[key] = value;
                } else if (value !== null && value !== '' && value !== undefined) {
                    queryParams[key] = value;
                }
            }

            return queryParams;
        },
    },
};
</script>

<style lang="scss">
body {
    #app {
        .notes-print-preview {
            .border {
                border: none !important;
            }

            h4 {
                color: black !important;
            }

            .theme--light.v-sheet--outlined {
                border: none !important;
            }

            .container.content-container.container-height.container--fluid {
                max-width: none !important;
            }

            .v-application, .container-height {
                padding-left: 0 !important;
                padding-right: 0 !important;
                background: white;
            }

            .v-application .pa-4 {
                padding: 0 !important;
            }

            .v-application .px-5 {
                margin: 5px !important;
            }

            .v-card > .pa-4 {
                margin: 0 5px !important;
                padding: 0 !important;
            }

            .v-btn.v-btn--depressed.v-size--small {
                display: none;
            }

            .v-card.mb-6 {
                margin-bottom: 40px !important;
            }

            .newIccStyles table tbody td {
                padding-left: 0 !important;
            }
        }
    }

    .print-footer-wrap {
        border-top: 1px solid black;
    }

    footer {
        padding: 0 10px;
    }

    .print-footer-text {
        font-size: 10px;
    }
}

@media print {
    footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: left;
        font-size: 12px;
        background: white;
        padding: 10px 0;
    }
    .v-card.v-sheet {
        page-break-inside: avoid;
    }
}
</style>
